import ReactDOM from 'react-dom/client'
import App from './App'
import { Provider } from 'react-redux'
import { store } from '@store'
import { ThemeProvider } from '@emotion/react'
import 'react-toastify/dist/ReactToastify.css'
import './global.css'
import { ToastContainer } from 'react-toastify'
import { ModalProvider } from '@context/ModalContext'
import { DropdownProvider } from '@context/DropdownContext'
import { CustomThemeProvider } from '@context/ThemeContext'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <CustomThemeProvider>
      <ToastContainer position="top-right" style={{ zIndex: 9999999999999 }} />
      <ModalProvider>
        <DropdownProvider>
          <App />
        </DropdownProvider>
      </ModalProvider>
    </CustomThemeProvider>
  </Provider>,
)
